export default "__VITE_ASSET__b302c227__"